/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

export interface QuestionnaireResultsCsvGetParams {
    questionnaireGuid: string
    version?: number | undefined
    includeTests: boolean
}

export function questionnaireResultsCsvGet(http: HttpClient, rootUrl: string, params: QuestionnaireResultsCsvGetParams, headers: HttpHeaders, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    const rb = new RequestBuilder(rootUrl, questionnaireResultsCsvGet.PATH, 'get');

    for (let headerKey of headers.keys()) {
        rb.header(headerKey, headers.get(headerKey));
    }

    rb.path('questionnaireGuid', params.questionnaireGuid, {"style":"simple"});

    if (params.version) {
        rb.query('version', params.version);
    }
    rb.query('includeTestInstances', params.includeTests);

    return http.request(
        rb.build({ responseType: 'blob', accept: '*/*', context })
    ).pipe(
        filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
        map((r: HttpResponse<any>) => {
            return r as StrictHttpResponse<Blob>;
        })
    );
}

questionnaireResultsCsvGet.PATH = '/api/v1/questionnaires/{questionnaireGuid}/responses/csv';
